(function () {
  var summary = document.getElementById("article-summary");
  if (!summary) {
    return;
  }

  var toggle = summary.querySelector(".article-summary__toggle");
  if (!toggle) {
    return;
  }
  summary.classList.add("article-summary--collapsible");
  toggle.setAttribute("aria-expanded", "false");

  var label = toggle.querySelector(".article-summary__toggle-label");
  if (label) {
    label.textContent = label.dataset.closed;
  }

  toggle.addEventListener("click", function () {
    var open = summary.classList.toggle("article-summary--open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (label) {
      label.textContent = open ? label.dataset.open : label.dataset.closed;
    }
  });
})();
